import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './Map.css';
import { uniqueId, Sizer } from '../../utils';
import MapGeoCollection from './MapGeoCollection';
import MapTrack from '../../containers/MapTrack';

const ymaps = window.ymaps;
const $ = window.$;

export default class Map extends Component {
  static childContextTypes = {
    getGeoCollection: PropTypes.func.isRequired,
    getYandexMap: PropTypes.func.isRequired,
  }

  constructor(props) {
    super(props);
    this.mapContainerId = uniqueId();
    this.days = {};
    this.componentWillReceiveProps(props);
  }

  state = { mapReady: false, mapZoom: 0 };

  getChildContext() {
    return {
      getYandexMap: () => this.yandexMap,
      getGeoCollection: () => this.yandexMap.geoObjects,
    };
  }

  componentDidMount() {
    ymaps.ready(() => {
      this.yandexMap = new ymaps.Map('yandexMap', {
        center: this.props.mapCenter || [59.918224, 30.335113],
        zoom: 11,
        controls: ['zoomControl', 'rulerControl'],
      });
      this.sizer = new Sizer($('#mapRoot'), $('#yandexMap'), () => {
        this.yandexMap.container.fitToViewport();
      });
      this.props.onMapReady();
      this.setState({ ...this.state, mapReady: true });
      this.tickTimer = setInterval(this.onTick, 300);
    });
  }

  componentWillReceiveProps(nextProps) {
    const { mapCenter } = nextProps;
    if (mapCenter !== this.props.mapCenter) {
      this.yandexMap.setCenter(mapCenter);
    }
  }

  componentWillUnmount() {
    if (this.sizer) {
      this.sizer.clear();
      delete this.sizer;
    }
    if (this.tickTimer) {
      clearInterval(this.tickTimer);
      delete this.tickTimer;
    }
  }

  onTick = () => {
    if (this.state.mapZoom !== this.yandexMap.getZoom()) {
      this.setState({ ...this.state, mapZoom: this.yandexMap.getZoom() });
    }
  }

  renderDays = () => (
    Object.keys(this.props.days).map(date => {
      const { days, selectedDay } = this.props;
      const day = days[date];
      return (
        <MapGeoCollection key={day.date} visible={day === selectedDay}>
          {this.renderTracks(day)}
        </MapGeoCollection>
      );
    })
  )

  renderTracks = day => {
    if (!this.state.mapReady) {
      return undefined;
    }
    return (
      <MapGeoCollection name="root">
        {Object.keys(day.tracks).map(trackId => (
          <MapTrack
            key={trackId + Date.parse(day.date)}
            track={day.tracks[trackId]}
            mapZoom={this.state.mapZoom}
          />
        ))}
      </MapGeoCollection>
    );
  }

  render() {
    return (
      <div id="mapRoot" className="Map">
        <div id="yandexMap" />
        {this.renderTracks(this.props.selectedDay)}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Map/Map.jsx